/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import LocalDate from './LocalDate';

const LocalDateView = ({ data, showIcon }) => (
    <div>
        {(showIcon) ? <i className="calendar icon"/> : <div></div>}
        {data != null && data !== '' ?
            <LocalDate data={data}/> : <span style={{color:'#999999'}}>Non impostata</span>
        }
    </div>
);

export default LocalDateView;


/** WEBPACK FOOTER **
 ** ./src/components/LocalDateView.jsx
 **/